import { CategoryVideo } from '@/model';
import {
  GetMediaCategoryVideoByIdResponse,
  GetMediaCategoryVideoItemResponse,
  GetMediaCategoryVideoResponse,
  PostMediaCategoryVideoResponse,
  PutMediaCategoryVideoResponse,
} from '@/services/response/category-video';

export class CategoryVideoConverter {
  static toDomainFromGetItemResponse(response: GetMediaCategoryVideoItemResponse): CategoryVideo {
    return {
      business_unit_uuid: response.business_unit_uuid,
      uuid: response.uuid,
      title: response.title,
      description: response.description,
      status: response.status,
      order: response.order,
      created_at: response.created_at,
      updated_at: response.updated_at,
    };
  }

  static toDomainFromPaginatedResponse(response: GetMediaCategoryVideoResponse): CategoryVideo[] {
    return response.data.map(CategoryVideoConverter.toDomainFromGetItemResponse);
  }

  static toDomainFromPostResponse(response: PostMediaCategoryVideoResponse): CategoryVideo {
    return {
      uuid: response.uuid,
      title: response.title,
      description: response.description,
      status: response.status,
      order: response.order,
      created_at: response.created_at,
      updated_at: response.updated_at,
    };
  }

  static toDomainFromByIdResponse(response: GetMediaCategoryVideoByIdResponse): CategoryVideo {
    return {
      uuid: response.uuid,
      title: response.title,
      description: response.description,
      status: response.status,
      order: response.order,
      created_at: response.created_at,
      updated_at: response.updated_at,
    };
  }

  static toDomainFromPutResponse(response: PutMediaCategoryVideoResponse): CategoryVideo {
    return {
      uuid: response.uuid,
      title: response.title,
      description: response.description,
      status: response.status,
      order: response.order,
      created_at: response.created_at,
      updated_at: response.updated_at,
    };
  }
}
